export const changeBudgetActions = {
  Set: 'SetAmount',
  Increase: 'IncreaseBudget',
  Decrease: 'DecreaseBudget',
};

export const changeBidActions = {
  SetAmount: 'SetAmount',
  IncreaseBid: 'IncreaseBid',
  DecreaseBid: 'DecreaseBid',
  BestBid: 'BestBid',
  FirstPageBid: 'FirstPageBid',
};

export const PauseActionValue = {
  Campaign: 'UserPaused',
  Ad: 'Paused',
  AdGroup: 'Paused',
  Keyword: 'Paused',
  AssetGroup: 'Paused',
};

export const nonTextActionsForKeyword = {
  RaiseToTopOfPage: 'RaiseToTopOfPage',
  RaiseToFirstPage: 'RaiseToFirstPage',
  ChangeBid: 'ChangeBid',
};
